import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'sdInputTooltipPipe'
})
export class SdInputTooltipPipe implements PipeTransform {
  transform(value: any, tooltip: string | ((inputValue: string) => string)): string {
    if (typeof (tooltip) === 'string') {
      return tooltip;
    }
    return tooltip(value);
  }
}
